import { useEffect } from "react";
import { taskService } from "../services/taskService";

export function useDailyTask(enabled: boolean, isMatchMode: boolean = false) {
  useEffect(() => {
    if (!enabled) return;

    taskService.checkIn();

    const intervalId = setInterval(() => {
      taskService.updateOnlineTime(isMatchMode);
    }, 60 * 1000);

    return () => clearInterval(intervalId);
  }, [enabled, isMatchMode]);
}
